import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const renderRequestNumber = (contactId, styles) => {
  if (contactId) {
    return (
      <p {...css(styles['contact-id'])}>{`Richiesta numero ${contactId}`}</p>
    )
  }
}

const renderSubtitle = (subtitle, styles) => {
  if (subtitle) {
    return <h2 {...css(styles.subtitle)}>{subtitle}</h2>
  }
}

const Title = props => (
  <div>
    <h1 {...css(props.styles.title)}>
      { (props.isLastStep) ? 'Accetta i contratti' : props.title}       
      {renderRequestNumber(props.contactId, props.styles)}
    </h1>
    {renderSubtitle(props.subtitle, props.styles)}
  </div>
)

Title.propTypes = {
  title: PropTypes.string.isRequired,
  contactId: PropTypes.string,
  subtitle: PropTypes.string,
  styles: PropTypes.object.isRequired
}

export default withStyles(Styles)(Title)



// WEBPACK FOOTER //
// ./components/title/index.js